import { registerPlugin } from '@capacitor/core';

export interface ShowIncomingCallOptions {
    callerName?: string;
    callerNumber?: string;
    conversationId?: string | number | null;
    callSid?: string | null;
    dealerId?: string | number | null;
    toNumber?: string | null;
}

export interface IncomingCallPlugin {
    showIncomingCall(options: ShowIncomingCallOptions): Promise<void>;
    dismissIncomingCall(): Promise<void>;
}

export const IncomingCall = registerPlugin<IncomingCallPlugin>('IncomingCall');
